import React from 'react'
import { trimText } from 'Helpers'

export const trimPasteText = (onChange: (value: string) => void) => {
	if (onChange)
		return (event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
			event.preventDefault()
			const { clipboardData } = event
			onChange(trimText(clipboardData.getData('Text')))
		}
	return undefined
}
